export default {
  api: {
    url: process.env.API_URL,
    host: process.env.API_HOST
  },
  redirect_url: process.env.OAUTH2_REDIRECT_URL,
  maintenanceBannerUrl: process.env.MAINTENANCE_BANNER_URL,
  auth0_domain: process.env.AUTH0_DOMAIN,
  auth0_client_id: process.env.AUTH0_CLIENT_ID,
  auth0_audience: process.env.AUTH0_AUDIENCE,
  google_client_id: process.env.GOOGLE_CLIENT_ID,
};
